import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Mail, Phone, MapPin } from 'lucide-react';
export function ContactPage() {
  return <>
      {/* Hero Section */}
      <Section className="py-20" background="offwhite" data-id="element-299">
        <div className="text-center mb-12" data-id="element-300">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-301">
            Contact Us
          </h1>
          <p className="text-xl font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-302">
            Get in touch with our team. We'd love to hear from you.
          </p>
        </div>
      </Section>

      {/* Contact Info & Form */}
      <Section background="white" data-id="element-303">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-304">
          {/* Contact Information */}
          <div data-id="element-305">
            <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-8" data-id="element-306">
              Get In Touch
            </h2>
            <div className="space-y-6" data-id="element-307">
              <div className="flex gap-4" data-id="element-308">
                <div className="flex-shrink-0" data-id="element-309">
                  <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-310">
                    <Mail size={24} className="text-white" data-id="element-311" />
                  </div>
                </div>
                <div data-id="element-312">
                  <h3 className="font-playfair font-bold text-xl text-primary-deep-blue mb-2" data-id="element-313">
                    Email
                  </h3>
                  <a href="mailto:natasha.farashamed@gmail.com" className="font-inter text-primary-royal-blue hover:underline" data-id="element-314">
                    natasha.farashamed@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-315">
                <div className="flex-shrink-0" data-id="element-316">
                  <div className="h-12 w-12 rounded-full bg-primary-royal-blue flex items-center justify-center" data-id="element-317">
                    <MapPin size={24} className="text-white" data-id="element-318" />
                  </div>
                </div>
                <div data-id="element-319">
                  <h3 className="font-playfair font-bold text-xl text-primary-deep-blue mb-2" data-id="element-320">
                    Location
                  </h3>
                  <p className="font-inter text-neutral-charcoal" data-id="element-321">
                    Los Angeles, California
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12" data-id="element-322">
              <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-323">
                Office Hours
              </h3>
              <p className="font-inter text-neutral-charcoal" data-id="element-324">
                Monday - Friday: 9:00 AM - 5:00 PM PST
              </p>
              <p className="font-inter text-neutral-charcoal" data-id="element-325">
                Saturday - Sunday: Closed
              </p>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-neutral-offwhite p-8 rounded-xl" data-id="element-326">
            <h2 className="text-2xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-327">
              Send Us a Message
            </h2>
            <form className="space-y-4" data-id="element-328">
              <div data-id="element-329">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-330">
                  Name *
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="Your name" data-id="element-331" />
              </div>
              <div data-id="element-332">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-333">
                  Email *
                </label>
                <input type="email" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="your@email.com" data-id="element-334" />
              </div>
              <div data-id="element-335">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-336">
                  Subject *
                </label>
                <input type="text" required className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="How can we help?" data-id="element-337" />
              </div>
              <div data-id="element-338">
                <label className="block font-inter font-medium text-primary-deep-blue mb-2" data-id="element-339">
                  Message *
                </label>
                <textarea required rows={6} className="w-full px-4 py-3 rounded-md border border-neutral-charcoal/20 focus:outline-none focus:ring-2 focus:ring-primary-royal-blue" placeholder="Your message..." data-id="element-340" />
              </div>
              <Button type="submit" className="w-full" data-id="element-341">
                Send Message
              </Button>
            </form>
          </div>
        </div>
      </Section>

      {/* Map or Additional Info */}
      <Section background="sand" data-id="element-342">
        <div className="text-center max-w-3xl mx-auto" data-id="element-343">
          <h2 className="text-3xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-344">
            We're Here to Help
          </h2>
          <p className="text-lg font-inter text-neutral-charcoal" data-id="element-345">
            Whether you're interested in donating, volunteering, partnering with
            us, or just want to learn more about our work, we'd love to hear
            from you. We typically respond within 1-2 business days.
          </p>
        </div>
      </Section>
    </>;
}